/* =========================================================
   ACHIEVEMENTS + STORIES
========================================================= */

import React from "react";
import SectionHeader from "./SectionHeader";

const AchievementsSection = ({ data }) => (
    <section
        className="student-achievement-strip"
        id="achievements"
    >

        <div className="container">

            {/* =================================================
                 HEADER
            ================================================== */}

            <SectionHeader
                eyebrow={data.eyebrow}
                title={data.title}
                description={data.description}
            />


            {/* =================================================
                 STUDENT STORIES
            ================================================== */}

            <div className="story-grid">

                {(data.items || []).map((item, i) => (

                    <div
                        className="story"
                        key={i}
                    >

                        <div
                            className="story-image"
                            style={
                                item.image
                                    ? {
                                        backgroundImage:
                                            `url(${item.image})`,
                                        backgroundSize: "cover",
                                        backgroundPosition: "center"
                                    }
                                    : {}
                            }
                        >
                            {!item.image && "Student Photograph"}
                        </div>


                        <div className="story-content">

                            <h3>
                                {item.title}
                            </h3>

                            <p>
                                {item.description}
                            </p>

                        </div>

                    </div>

                ))}

            </div>


            {/* =================================================
                 ACHIEVEMENT STRIP
            ================================================== */}

            <div className="achievement-strip-grid">

                {(data.achievements || []).map((item, i) => (

                    <div
                        className="achievement-strip-item"
                        key={i}
                    >

                        <strong>
                            {item.value}
                        </strong>

                        <span>
                            {item.title}

                            <small>
                                {item.meta}
                            </small>
                        </span>

                    </div>

                ))}

            </div>


            {/* =================================================
                 LEARN MORE
            ================================================== */}

            {data.link && (
                <div className="achievement-strip-action">

                    <a
                        href={data.link.url}
                        className="btn btn-primary"
                    >
                        {data.link.label || "Learn More"}
                    </a>

                </div>
            )}

        </div>

    </section>
);

export default AchievementsSection;